import { useRouteLoaderData } from 'react-router';

import type { Strings } from './catalogue';
import type { loader as rootLoader } from '@/root';
import { englishStrings } from './catalogue';

/**
 * The UI strings for the active language, resolved by the root loader. Falls
 * back to the English catalogue so a component rendered from an error boundary
 * (where the root loader never ran) still has copy.
 */
export function useStrings(): Strings {
  return useRouteLoaderData<typeof rootLoader>('root')?.strings ?? englishStrings;
}
